/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Log } from "~/models/log";
import { Prerequisite } from "~/models/prerequisite";

export type ProductIdRouteParams = {
  productId: string;
};

export type ProductListItem = {
  id: string;
  name: string;
};

export type Product = {
  description: string;
  id: string;
  log: Log;
  name: string;
  owner?: {
    id: string;
    email: string;
  };
  pricing: string;
  sfProductLink: string;
  prerequisites: Array<Prerequisite>;
};

export const productInitialState: Product = {
  description: "",
  id: "",
  log: {
    created: {
      author: "",
      time: "",
    },
    modified: {
      author: "",
      time: "",
    },
  },
  name: "",
  owner: {
    id: "",
    email: "",
  },
  pricing: "",
  sfProductLink: "",
  prerequisites: [
    {
      text: "",
      id: "",
    },
  ],
};
